<template>
  <div id="app">
    <app-header></app-header>
    <transition name="slide" mode="out-in">
      <router-view></router-view>
    </transition>
    <app-footer></app-footer>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
  import Header from '@/components/layout/header.vue';
  import Footer from '@/components/layout/footer.vue';
  import axios from 'axios'

  export default {
    name: 'App',
    components: {
      appHeader: Header,
      appFooter: Footer
    },

    mounted(){
      this.loadEnvironment();
      this.loadData();
      this.interval = setInterval(function () {
        this.loadData();
      }.bind(this), 10000);
    },
    methods: {
      loadData() {
        // All functions where periodic check is required.
      },

      loadEnvironment() {
        // Check if user is authenticated
        if (this.$store.getters['auth/isAuthenticated'] === true) {
          // Fetch All Cities
          this.$store.dispatch('environment/fetchCities')
            .then(response => {}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          this.$store.dispatch('environment/fetchCitiesKSA')
              .then(response => {}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          this.$store.dispatch('environment/fetchCitiesBahrain')
              .then(response => {}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Fetch All Countries
          this.$store.dispatch('environment/fetchCountries')
            .then(response => {}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});
          // Load Nationalities
          this.$store.dispatch('environment/fetchNationalities')
            .then(response => {}) .catch(error => {this.$snotify.error(error.error.message, error.error.title);});

          // TODO: Load Company Settings

        }

      },

      loadUsersData() {
        // TODO: Load All Users

        // TODO: Load Profile

        // TODO: Load Permissions

        // TODO: Load User Settings
      }
    },

    beforeDestroy: function(){
      clearInterval(this.interval);
    }

  }
</script>
<style>
  #app {
    /*font-family: 'Source Sans Pro', 'Roboto', Helvetica, Arial, sans-serif;*/
    /*-webkit-font-smoothing: antialiased;*/
    /*-moz-osx-font-smoothing: grayscale;*/
    /*color: #2c3e50;*/
      background-color: #f1eee9;
  }
  .rtlx{
    direction: RTL !important;
   }
  .rtl {
    direction: RTL !important;
    text-align: right;
  }
  .rtl p, th, tr, span, h1, h2, h3, h4, h5, a, li, button, input {font-family: 'Cairo', sans-serif !important;}
  .rtl .shopping-cart .price{right: -70px !important;}
  .rtl .pull-right {float:left !important;}
  .rtl li::after {padding-right: 10px !important;}
  .rtl .mobile-hide{float: left !important;}
  .rtl .custom-search{padding-left: 10px !important;}
  .rtl .custom-search .form-control{padding-right: 50px !important;}
  .rtl .middle-link{margin-right: 10px !important; padding-right: 20px !important; border-left: solid 1px #dcdcdc !important;}
  .rtl .middle-link2{margin-right: 100px !important;}



  .fa-icon{
    padding-right: 2px;
    vertical-align: middle !important;
    margin-bottom: 4px;
  }

</style>


// WEBPACK FOOTER //
// src/App.vue